






























import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { mixins } from "vue-class-component";
import LoadingMixin from "@/mixins/LoadingMixin";
import ContentMixin from "@/mixins/ContentMixin";
import {
  IFlowSchedule,
  IFlowSchedules,
  FlowStatus,
} from "@/store/modules/flow/types";

const namespace: string = "flowModule";

@Component({
  name: "assessment-wait",
})
export default class AssessmentWait extends mixins(LoadingMixin, ContentMixin) {
  public isLoading = true;

  @Getter("goto", { namespace })
  public goto!: string;

  @Getter("schedule", { namespace })
  public schedule!: IFlowSchedule;

  @Getter("schedules", { namespace })
  public schedules!: IFlowSchedules;

  @Action("startSection", { namespace })
  public startSection!: () => Promise<void>;

  @Action("takeSection", { namespace })
  public takeSection!: (status: FlowStatus) => Promise<void>;

  @Action("previous", { namespace })
  public previous!: (remainingTime: number) => Promise<void>;

  public async beforeMount() {
    try {
      this.isLoading = true;
      this.$Progress.start();
      await this.startSection();
      this.$Progress.finish();
    } catch (e) {
      this.$Progress.fail();
    } finally {
      this.isLoading = false;
    }
  }

  public async onPreviousSection() {
    if (this.goto !== "/assessment-wait") {
      await this.$router.push(this.goto);
    }
  }

  public async onStartSection() {
    try {
      await this.takeSection(FlowStatus.SectionStarted);
      await this.$router.replace(this.goto);
    } catch (e) {
      if (e.status !== 428) {
        this.$notify({
          type: "error",
          duration: 2000,
          group: "error",
          title: "An error ocurred",
          text: "Try again latter",
        });
      }
    }
  }
}
